require('./dropdownPlans.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ components
const PlanItem = require('./planItem');

const PlanItemSelected = props => {
    const { value } = props;
    const plan = value
    const id = `${plan.id}_Selected`;

    return (
        <div id={id} className="Select-value dropdown-plans__account">
            <div className="Select-value-label">
                <div className="dropdown-plans__account-description">
                    <PlanItem plan={plan}/>
                </div>
            </div>
        </div>
    );
};

PlanItemSelected.propTypes = {
    value: PropTypes.object
};

module.exports = PlanItemSelected;